<template>
  <div>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-card v-else>
      <v-card-title class="text-uppercase"
        >{{ compra.tipo }}<v-spacer></v-spacer>
        
        <v-btn
          v-if="compra.tipo == 'compra' && !compra.fechaStock"
          :color="compra.enTransito ? 'green' : 'orange'"
          fab
          small
          dark
          :loading="loadingEnTransito"
          @click="_enTransito()"
        >
          <v-icon>mdi-transit-connection-horizontal</v-icon>
        </v-btn>
        <v-btn
          v-if="compra.tipo == 'compra' && !compra.fechaStock"
          class="ma-2"
          color="green"
          fab
          small
          dark
          @click="_altaStock()"
        >
          <v-icon>mdi-clipboard-check-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="compra.tipo == 'pedido'"
          color="green"
          fab
          small
          dark
          @click="_realizarCompra()"
        >
          <v-icon>mdi-cart-outline</v-icon>
        </v-btn>
        <v-btn
        class="ma-2"
          v-if="compra.tipo == 'compra' && !compra.transporte"
          color="green"
          fab
          small
          dark
          @click="abrirCostoTransporte()"
        >
          <v-icon>mdi-truck-check-outline</v-icon>
        </v-btn>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" v-if="compra.usuario">
                  Usuario
                </th>
                <th class="text-left">
                  Fecha y Hora de Pedido
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ compra.usuario.nombre }}
                </td>
                <td>
                  {{
                    $moment(compra.fechaAlta).format(
                      "dddd DD [de] MMMM YYYY H:mm"
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Proveedor
                </th>
                <th class="text-left" v-if="compra.tipo == 'compra'">
                  Comprobante de Compra
                </th>
                <th class="text-left" v-if="compra.tipo == 'compra'">
                  Fecha y Hora de Compra
                </th>
                <th class="text-left" v-if="compra.fechaStock">
                  Fecha y Hora de Alta de Mercaderia
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ compra.proveedor.nombre }}
                  <v-icon @click="verProveedor()">mdi-eye</v-icon>
                </td>
                <td v-if="compra.tipo == 'compra'">
                  {{ compra.comprobanteCompra.tipo }}
                  {{ compra.comprobanteCompra.numero }}
                </td>
                <td v-if="compra.tipo == 'compra'">
                  {{
                    $moment(compra.fechaCompra).format(
                      "dddd DD [de] MMMM YYYY H:mm"
                    )
                  }}
                </td>
                <td v-if="compra.fechaStock">
                  {{
                    $moment(compra.fechaStock).format(
                      "dddd DD [de] MMMM YYYY H:mm"
                    )
                  }} <v-icon @click="verComprobanteMercaderia()">mdi-eye</v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table v-if="compra.transporte">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Transporte
                </th>
                <th class="text-left">
                  Comprobante de Transporte
                </th>
                <th class="text-left">
                  Costo total
                </th>
                <th class="text-left">
                  Costo por Unidad estimado
                </th>
                <th class="text-left" v-if="compra.fechaRecibido">
                  Fecha y Hora de Recepcion
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ compra.transporte.nombre }}
                  <v-icon @click="verTransporte()">mdi-eye</v-icon>
                </td>
                <td>
                  {{ compra.comprobanteTransporte.tipo }}
                  {{ compra.comprobanteTransporte.numero }}
                </td>
                <td>
                  {{ compra.costoTransporte }}
                </td>
                <td>
                  {{ compra.costoPorUnidad }}
                </td>
                <td v-if="compra.fechaRecibido">
                  {{
                    $moment(compra.fechaRecibido).format(
                      "dddd DD [de] MMMM YYYY H:mm"
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Producto
                </th>
                <th class="text-left">
                  Cantidad
                </th>
                <th class="text-left">
                  Costo por unidad
                </th>
                <th class="text-left">
                  Costo total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in compra.productos" :key="index">
                <td>
                  {{ item.producto.nombre }}
                  <v-icon @click="verProducto(item.producto._id)"
                    >mdi-eye</v-icon
                  >
                </td>
                <td>
                  {{ item.cantidad }}
                </td>
                <td>
                  {{ item.costo }}
                </td>
                <td>
                  {{ item.total }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Total de Compra
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-right">
                  <strong>{{ compra.totalCompra }}</strong>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table v-if="compra.tipo == 'compra'">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Medio de Pago
                </th>
                <th class="text-left">
                  Monto
                </th>
                <th class="text-left">
                  Comprobante
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in compra.mediosPago" :key="index">
                <td>
                  {{ item.billetera.nombre }}
                </td>
                <td>
                  {{ item.monto }}
                </td>
                <td>
                  {{ item.comprobante }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-dialog
      persistent
      transition="dialog-top-transition"
      max-width="600"
      v-model="dialogCostoTransporte"
    >
      <v-card>
        <v-toolbar color="primary" dark>Costo de Transporte</v-toolbar>
        <v-card-text>
          <v-select
            label="Transporte"
            v-model="costoTransporte.transporte"
            :items="listadoTransportes"
            :loading="loadingTransportes"
            item-text="nombre"
            item-value="_id"
          ></v-select>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                label="Comprobante"
                v-model="costoTransporte.comprobante.tipo"
                :items="tipoComprobante"
                :loading="loadingTipoComprobante"
                item-text="descripcion"
                item-value="codigo"
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Numero"
                v-model="costoTransporte.comprobante.numero"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6"
              ><v-text-field
                label="Monto"
                v-model="costoTransporte.monto"
                prefix="$"
                type="number"
              ></v-text-field
            ></v-col>
            <v-col cols="12" md="6"
              ><v-text-field
                label="Costo por Unidad estimado"
                v-model="costoTransportePorUnidad"
                prefix="$"
                suffix="/ u."
                disabled
              ></v-text-field
            ></v-col>
          </v-row>
          <v-btn
            block
            :dark="verificarTransporte"
            color="primary"
            :disabled="!verificarTransporte"
            :loading="loadingCostoTransporte"
            @click="ingresarCostoTransporte()"
            >Ingresar costo de transporte</v-btn
          >
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="cerrarCostoTransporte()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Compras_Ver",
  data: () => ({
    loading: true,
    compra: null,
    costoTransporte: {
      transporte: null,
      comprobante: {
        tipo: null,
        numero: null,
      },
      monto: 0,
    },
    listadoTransportes: [],
    tipoComprobante: [],
    dialogCostoTransporte: false,
    loadingTransportes: false,
    loadingTipoComprobante: false,
    loadingCostoTransporte: false,
    loadingEnTransito: false
  }),
  computed: {
    _id() {
      return this.$route.params._id;
    },
    verificarTransporte() {
      if (
        !this.costoTransporte.transporte ||
        !this.costoTransporte.comprobante.tipo ||
        !this.costoTransporte.comprobante.numero ||
        isNaN(this.costoTransporte.monto) ||
        this.costoTransporte.monto <= 0
      )
        return false;
      return true;
    },
    sumaCantidadProductos() {
      return this.compra
        ? this.compra.productos.reduce(
            (suma, producto) => suma + producto.cantidad,
            0
          )
        : 0;
    },
    costoTransportePorUnidad() {
      return this.costoTransporte.monto
        ? parseFloat(
            this.costoTransporte.monto / this.sumaCantidadProductos
          ).toFixed(2)
        : 0;
    },
  },
  methods: {
    async _obtenerCompra() {
      this.loading = true;
      try {
        const compra = await axios.get(`/compras/${this._id}`);
        this.compra = compra.data;
      } catch (error) {}
      this.loading = false;
    },
    async _obtenerTransportes() {
      this.loadingTransportes = true;
      try {
        const transportes = await axios.get("/personas/transporte");
        this.listadoTransportes = transportes.data;
      } catch (error) {
        console.log(error);
      }
      this.loadingTransportes = false;
    },
    async _obtenerTiposComprobantes() {
      this.loadingTipoComprobante = true;
      try {
        const comprobantes = await axios.get("/compras/tipoComprobantes");
        this.tipoComprobante = comprobantes.data;
      } catch (error) {
        console.log(error);
      }
      this.loadingTipoComprobante = false;
    },
    verProveedor() {
      this.$router.push(`/personas/${this.compra.proveedor._id}`);
    },
    verProducto(_id) {
      this.$router.push(`/productos/${_id}`);
    },
    verTransporte() {
      this.$router.push(`/personas/${this.compra.transporte._id}`);
    },
    async _enTransito(){
      this.loadingEnTransito = true
      try {
        this.compra.enTransito = !this.compra.enTransito
        await axios.post("/compras/enTransito", { _id: this._id, estado: this.compra.enTransito})
      } catch (error) {
        console.log(error)
      }
      this.loadingEnTransito = false
    },
    _realizarCompra() {
      this.$router.push({
        name: "Compras_Nuevo",
        params: {
          compra: this.compra,
        },
      });
    },
    
    verComprobanteMercaderia()
    {
      this.$router.push(`/mercaderias/${this.compra.comprobanteAltaStock}`)
    },
    abrirCostoTransporte() {
      this.dialogCostoTransporte = true;
      this._obtenerTiposComprobantes();
      this._obtenerTransportes();
    },
    cerrarCostoTransporte() {
      this.dialogCostoTransporte = false;
      this.costoTransporte = {
        transporte: null,
        comprobante: {
          tipo: null,
          numero: null,
        },
        monto: 0,
      };
    },
    async ingresarCostoTransporte() {
      this.loadingCostoTransporte = true
      try {
        await axios.post('/compras/costoTransporte', {_id: this._id, ...this.costoTransporte, cantidadProductos: this.sumaCantidadProductos, costoPorUnidad: this.costoTransportePorUnidad})
        this.cerrarCostoTransporte()
        this._obtenerCompra()
      } catch (error) {
        console.log(error)
      }
      this.loadingCostoTransporte = false
    },
    _altaStock() {
      this.$router.push({name: 'Mercaderias_Nuevo', params: { compra: this.compra }})
    },
    _cerrar() {
      this.$router.go(-1);
    },
  },
  created() {
    this._obtenerCompra();
  },
};
</script>
